import React, {Fragment, useEffect, useState} from 'react';

import {useFilePicker} from 'use-file-picker';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import PropTypes from "prop-types";

import './SingleFilePicker.scss' ;

const ReactHookFormSingleFilePicker = (props) =>
{
    const accept = props.options.accept === undefined ? ['.doc', '.pdf', '.docx', '.jpg', '.png'] : props.options.accept ;
    const maxSizeMb = props.options.maxSizeMb === undefined ? 20 : props.options.maxSizeMb ;

    const [openFileSelector, {filesContent, loading, errors, plainFiles, clear}] = useFilePicker({
        multiple: false,
        readAs: 'DataURL', // availible formats: "Text" | "BinaryString" | "ArrayBuffer" | "DataURL"
        accept: accept,
        maxFileSize: maxSizeMb, // Mb
        readFilesContent: true, // ignores file content
    });

    const resetField = () => {
        props.onChange ( "" );
        clear();
    }

    const cancelBtnStyle = {color: "red", fontWeight: "bold", cursor: "pointer", position: "absolute", bottom: "7px", right: "10px"}
    
    useEffect(() =>
    {
        if ( filesContent.length > 0 )
        {
            props.onChange ( filesContent ) ;
        }
    }, [filesContent]);

    return (
        <Fragment>
<div style={{position: "relative"}}>
            <div ref={props.inputRef} className='picker-row'>
                <button name={props.name} type='button' onClick={() => openFileSelector()}>Select file</button>
                {plainFiles.map(file => (
                    <div key={file.name}>{file.name}</div>
                ))}
            </div>
            {!!filesContent?.length && 
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id="tooltip-right">
                            Remove Document
                        </Tooltip>
                    }
                >   
                        <div onClick={() => resetField()} style={cancelBtnStyle}>
                            X
                        </div>
                </OverlayTrigger>
            }
            {errors !== null && errors.length > 0 && errors[0].fileSizeTooSmall && 'File size is too small!'}
            {errors !== null && errors.length > 0 && errors[0].fileSizeToolarge && 'File size is too large!'}
            {errors !== null && errors.length > 0 && errors[0].readerError && 'Problem occurred while reading file!'}
            {errors !== null && errors.length > 0 && errors[0].maxLimitExceeded && 'Too many files'}
            {errors !== null && errors.length > 0 && errors[0].minLimitNotReached && 'Not enough files'}
</div>
        </Fragment>
    )
}

export default ReactHookFormSingleFilePicker;

ReactHookFormSingleFilePicker.defaultProps =
    {}

ReactHookFormSingleFilePicker.propTypes = {
    onChange: PropTypes.func.isRequired,
};